import cx from 'classnames'
import {ReactComponent as CheckIcon} from 'icons/check.svg'

type Props = {
  index: number
  name: string
  active: boolean
  enabled: boolean
  completed: boolean
  path: string
}

export const Step = ({index, name, active, enabled, completed, path}: Props) => {
  const goToStep = () => {
    window.location.href = path
  }

  return (
    <div
      className={cx(
        'flex flex-col w-full',
        enabled && !active ? 'd:cursor-pointer d:hover:opacity-80' : 'cursor-default pointer-events-none'
      )}
      onClick={goToStep}
    >
      <div className={cx('w-full h-[3px]', enabled ? (active ? 'bg-theme' : 'bg-theme opacity-50') : 'bg-[#CFD6DC]')} />
      <div
        className={cx(
          'hidden d:flex font-medium gap-[10px] py-4 items-center',
          enabled ? (active ? 'text-theme' : 'text-french-blue-base') : 'text-[#CFD6DC]'
        )}
      >
        {completed ? (
          <div className="rounded-full flex justify-center items-center bg-theme w-[20px] h-[20px]">
            <CheckIcon className="text-white w-[12px] h-[12px]" />
          </div>
        ) : (
          <div>{index}</div>
        )}
        <div className="text-sm leading-6">{name}</div>
      </div>
    </div>
  )
}
